import React from "react";

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "h-10 w-auto" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative">
        <img
          src="/assets/logo.png"
          alt="Bass Ministry Logo"
          className="w-10 h-10 rounded-full"
        />
        Bassministry 2025
      </div>
      <span className="ml-2 text-xl font-display font-bold text-primary">
        BASS MINISTRY
      </span>
    </div>
  );
};

export default Logo;
